import Categories from 'ContentUtils/constants/Categories';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getContentAccessControlPanelSaveFailureNotification, getContentAccessControlPanelSaveSuccessNotification } from 'ui-memberships-settings-lib/utils/alerts';
import { trackContentAccessControlModalPanelSave } from 'ui-memberships-settings-lib/utils/tracking';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
export const displayAndTrackAudienceAccessUpdateSuccess = ({
  isLandingPage,
  publicAccessRuleType,
  password,
  count = 1
}) => {
  const controlAudienceAccessData = {
    contentCategoryId: isLandingPage ? Categories['landing-page'].id : Categories['site-page'].id,
    contentCount: count,
    publicAccessRuleType: password ? PublicAccessRuleTypes.PASSWORD : publicAccessRuleType
  };
  FloatingAlertStore.addAlert(getContentAccessControlPanelSaveSuccessNotification(controlAudienceAccessData));
  trackContentAccessControlModalPanelSave(controlAudienceAccessData);
};
export const displayAudienceAccessUpdateError = ({
  isLandingPage,
  count = 1
}) => {
  FloatingAlertStore.addAlert(getContentAccessControlPanelSaveFailureNotification({
    contentCategoryId: isLandingPage ? Categories['landing-page'].id : Categories['site-page'].id,
    contentCount: count
  }));
};